import { render, staticRenderFns } from "./hzxxTJ.vue?vue&type=template&id=58bdf6dc&scoped=true"
import script from "./hzxxTJ.vue?vue&type=script&lang=js"
export * from "./hzxxTJ.vue?vue&type=script&lang=js"
import style0 from "./hzxxTJ.vue?vue&type=style&index=0&id=58bdf6dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bdf6dc",
  null
  
)

export default component.exports